import { ErrorRetry } from "../../common/ErrorRetry";
import { RevenueHeatmap } from "./RevenueHeatmap";
import { AirlineRevenueChart } from "./AirlineRevenueChart";

export function ReportSummaryMarketSection({
  revenueGeoState,
  revenueByGeo,
  flightRevenueState,
  flightRevenue,
}) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {revenueGeoState.loading ? (
        <RevenueHeatmap revenueByGeography={[]} loading={true} />
      ) : revenueGeoState.error ? (
        <ErrorRetry
          message={revenueGeoState.message}
          onRetry={revenueGeoState.onRetry}
        />
      ) : (
        <RevenueHeatmap revenueByGeography={revenueByGeo} loading={false} />
      )}

      {flightRevenueState.loading ? (
        <AirlineRevenueChart flightRevenueByAirline={[]} loading={true} />
      ) : flightRevenueState.error ? (
        <ErrorRetry
          message={flightRevenueState.message}
          onRetry={flightRevenueState.onRetry}
        />
      ) : (
        <AirlineRevenueChart
          flightRevenueByAirline={flightRevenue}
          loading={false}
        />
      )}
    </div>
  );
}
